import React, { useState } from "react";
import OpenBetsTable from "../openBets/OpenBetsTable";
import { errorHandler } from "../ErrorHandler";
import { successMsg } from "../SuccessHandler";
import ApiCall from "../../constants/Api";
import { helpAxios } from "../../helpers/helpAxios";
import Swal from "sweetalert2";
import SiteConfig from "../../constants/SiteConfig";
import ErrorCodes from "../../constants/ErrorCodes";
import WagerDetailsModal from "./WagerDetailModal";
import { useDeleteFunctions, useSelectFunctions } from "../../functions";
import VoidReasonModal from "./VoidReasonModal";

const OpenBetsModal = ({
  playerName,
  openBetsInfo,
  setOpenBetsInfo,
  getTimeUTCFormat,
  loginPlayerInfo,
  getDateUTCFormat,
  loading,
  getStatistics,
  session,
  setSessionNoLongerExists,
  getOpenBetsDetailModal,
  setOpenBetDetails,
  openBetDetails,
}) => {
  const [isWagerModalOpen, setIsWagerModalOpen] = useState(false);
  const { voidWagerList } = useDeleteFunctions();
  const { getVoidReasonList } = useSelectFunctions();
  const [isVoidModalOpen, setIsVoidModalOpen] = useState(false);
  const [selectedTickets, setSelectedTickets] = useState([]);
  const [reasonList, setReasonList] = useState([]);

  let riskAmountWagers = [],
    totalAtRisk;

  if (openBetsInfo && openBetsInfo.length > 0) {
    openBetsInfo.forEach((data, i) => {
      riskAmountWagers.push(parseInt(data.RiskAmount));
    });
  }

  const openWagerDetailsModal = async (rowData) => {
    try {
      if (rowData.IDWager > 0) {
        await getOpenBetsDetailModal(rowData.IDWager);
        setIsWagerModalOpen(true);
      } else {
        errorHandler("No details available for this transaction1");
      }
    } catch {
      return;
    }
  };

  totalAtRisk = riskAmountWagers.reduce((a, b) => a + b, 0);

  const voidWager = async (ticket) => {
    if (ticket.EPOS) {
      voidTicket(ticket);
    } else {
      const response = await getVoidReasonList(session);
      setReasonList(response.List);
      handleVoidClick([ticket.TicketNumber]);
    }
  };

  const voidTicket = (data) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Void Ticket!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.value) {
        const fetchData = async () => {
          const res = await helpAxios(
            SiteConfig.RACING_TICKET_VALIDATOR_SVC,
            ApiCall.VOID,
            {
              Session: "",
              Player: playerName,
              TicketID: data.TicketNumber,
              IDCall: loginPlayerInfo.IdCall,
              LocalApp: true,
              VoidReason: SiteConfig.VOID_REASON,
              IDUser: loginPlayerInfo.IdUser,
              AppSystem: SiteConfig.SYSTEM_ID,
            },
            session,
          );
          if (res.error) {
            let errorDet;
            if (res.errorDetails) {
              errorDet = res.errorDetails;
            }
            if (
              res.Result === ErrorCodes.InvalidSession ||
              res.Result === ErrorCodes.SessionNoLongerExists
            ) {
              setSessionNoLongerExists(true);
            } else {
              errorHandler(res.error, errorDet);
            }
          } else {
            successMsg("Race Ticket #" + data.TicketNumber + " voided");
            getStatistics();
            const updatedItems = openBetsInfo.filter(
              (ticket) => ticket.TicketNumber !== data.TicketNumber,
            );
            setOpenBetsInfo(updatedItems);
          }
        };

        fetchData();
      }
    });
  };

  const handleVoidClick = (tickets) => {
    setSelectedTickets(tickets);
    setIsVoidModalOpen(true);
  };

  return (
    <>
      <div
        className="modal fade bd-example-modal-lg"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        data-keyboard="false"
        data-backdrop="static"
        id="openBetsModal"
        style={{ maxHeight: "800px" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header headerModals">
              <h5
                className="modal-title h4"
                id="myLargeModalLabel"
                style={{
                  width: "100%",
                  textAlign: "center",
                }}
              >
                Open Bets - {playerName}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <OpenBetsTable
                openBetsInfo={openBetsInfo}
                getDateUTCFormat={getDateUTCFormat}
                getTimeUTCFormat={getTimeUTCFormat}
                voidWager={voidWager}
                loading={loading}
                openWagerDetailsModal={openWagerDetailsModal}
              />
              <VoidReasonModal
                show={isVoidModalOpen}
                onHide={() => setIsVoidModalOpen(false)}
                options={reasonList || []}
                data={selectedTickets}
                voidWagerList={voidWagerList}
                session={session}
                openBetsInfo={openBetsInfo}
                getStatistics={getStatistics}
                setOpenBetsInfo={setOpenBetsInfo}
              />
            </div>
            <div className="modal-footer" style={{ justifyContent: "inherit" }}>
              <div style={{ color: "#a6a6a6", width: "90%" }} className="ml-2">
                {openBetsInfo.length} Wager(s)
                <span style={{ marginLeft: "60px" }}>
                  At Risk: $ {totalAtRisk}
                </span>
              </div>
              <div style={{ textAlign: "right" }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isWagerModalOpen && (
        <WagerDetailsModal
          onHide={() => {
            setIsWagerModalOpen(false);
            setOpenBetDetails({});
          }}
          selectedWager={openBetDetails}
          loginPlayerInfo={loginPlayerInfo}
          getDateUTCFormat={getDateUTCFormat}
        />
      )}
    </>
  );
};

export default OpenBetsModal;
